import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var Trend = createSvgIcon(React__default.createElement("path", { clipRule: "evenodd", d: "M14 5.5H22V13.5L18.7075 10.2075L13.1045 16.1839L12.375 16.9621L11.6455 16.1839L8.625 12.9621L3.72954 18.1839L3.0456 18.9135L1.58652 17.5456L2.27046 16.8161L7.89546 10.8161L8.625 10.0379L9.35454 10.8161L12.375 14.0379L17.2705 8.81606L17.2925 8.79253L14 5.5Z", fillRule: "evenodd" }), 'Trend');

export { Trend };
